(function() {
  'use strict';
  angular.module('app.maps')
    .directive('mapLoader', function() {
      return {
        restrict: 'E',
        templateUrl: 'modules/core/loader/loader.html',
        replace: 'true',
        controller: 'LoaderCtrl',
        bindToController: true
      };
    });
}());
